import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { bayesProbe, capabilities, fitToClinic } from '../../../data/snak3';
import { BayesianOverlay } from '../../BayesianOverlay';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FitToClinicScreen() {
  const [probeOpen, setProbeOpen] = useState(false);
  return <div className="relative flex flex-1 flex-col" data-id="element-395" data-mp="p7tf8kfjiu6h">
      <div className="flex items-start justify-between gap-3" data-id="element-396" data-mp="p57ccy3lh2ul">
        <motion.h2 initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.26,
        ease: EASE
      }} className="font-display text-[26px] font-bold uppercase leading-[0.98] tracking-tight text-paper" data-id="element-397" data-mp="u5cy5xn6nv4r">
          {fitToClinic.headline[0]}
          <span className="mt-1 block text-ozGreen" data-id="element-398" data-mp="17z48v9cnhl22">{fitToClinic.headline[1]}</span>
        </motion.h2>

        <motion.button type="button" onClick={() => setProbeOpen(true)} animate={{
        opacity: [1, 0.5, 1]
      }} transition={{
        duration: 1.6,
        repeat: Infinity,
        ease: 'linear'
      }} className="mt-1 shrink-0 rounded-full bg-ozGreen px-3 py-1.5 text-[10.5px] font-bold text-ozNavy transition-opacity duration-150 hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-ozGreen focus-visible:ring-offset-2 focus-visible:ring-offset-ozNavy" data-id="element-399" data-mp="1cxe0j9z623ix">
          {bayesProbe.trigger}
        </motion.button>
      </div>

      <p className="mt-3 text-[12px] leading-relaxed text-paper/70" data-id="element-400" data-mp="3swk1fqx574su">{fitToClinic.lead}</p>

      <div className="mt-5 grid grid-cols-2 gap-2" data-id="element-401" data-mp="3o5abep7olzgf">
        <p className="flex items-center gap-1.5 text-[9px] font-semibold uppercase tracking-micro text-ozGreen" data-id="element-402" data-mp="3o3z5ojuoehmo">
          <CheckIcon className="h-3 w-3 shrink-0" aria-hidden="true" data-id="element-403" data-mp="kh09cv87jsfd" />
          {fitToClinic.doesLabel}
        </p>
        <p className="flex items-center gap-1.5 text-[9px] font-semibold uppercase tracking-micro text-paper/50" data-id="element-404" data-mp="fqjv58wkc2ry">
          <MinusIcon className="h-3 w-3 shrink-0" aria-hidden="true" data-id="element-405" data-mp="ym8wwdewv6dc" />
          {fitToClinic.doesNotLabel}
        </p>
      </div>

      <ul className="mt-2 flex flex-col gap-1.5" data-id="element-406" data-mp="13l3s6eu2enec">
        {capabilities.map((row, i) => <motion.li key={row.does} initial={{
        opacity: 0,
        y: 6
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.22,
        delay: 0.08 + i * 0.05,
        ease: EASE
      }} className="grid grid-cols-2 gap-2" data-id="element-407" data-mp="ptfck1klxgsm" data-mpi={i}>
            <span className="rounded-lg bg-ozGreen/[0.16] px-3 py-2.5 text-[11px] leading-snug text-paper" data-id="element-408" data-mp="kvdw7oekfvku">
              {row.does}
            </span>
            <span className="rounded-lg border border-paper/15 px-3 py-2.5 text-[11px] font-semibold leading-snug text-paper/55" data-id="element-409" data-mp="6xfnozmxetd9">
              {row.doesNot}
            </span>
          </motion.li>)}
      </ul>

      <motion.p initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.26,
      delay: 0.34,
      ease: EASE
    }} className="mt-auto pt-5 font-display text-[19px] font-semibold leading-snug text-paper" data-id="element-410" data-mp="25az0fwbvqr6o">
        {fitToClinic.takeaway}
      </motion.p>

      <AnimatePresence data-id="element-411" data-mp="3dyn9k7q72u3">
        {probeOpen && <BayesianOverlay probe={bayesProbe} tone="dark" onClose={() => setProbeOpen(false)} data-id="element-412" data-mp="3eq6rwo1ta40" />}
      </AnimatePresence>
    </div>;
}